export default __webpack_public_path__ + "static/media/codablexLogo.6ebab6d3.svg";